import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/UserContext'; // Assicurati che il percorso sia corretto

const TrainerRoute = () => {
    const { user, loading } = useUser();

    if (loading) {
        return <div>Caricamento...</div>; // Mostra uno stato di caricamento se il contesto è ancora in caricamento
    }

    // Se l'utente esiste e il ruolo è 'trainer', permetti l'accesso alla rotta, altrimenti reindirizza al login
    return user && user.role === 'trainer' ? <Outlet /> : <Navigate to="/login" />;
};

export default TrainerRoute;
